import { AdminRole, EventType, Referral, UserRole, UserStatus } from "@/types";

export const formatAdminRoleToName = (role: AdminRole) => {
  switch (role) {
    case AdminRole.ADMIN: {
      return "Admin";
    }

    case AdminRole.SUPER_ADMIN: {
      return "Admin+";
    }

    case AdminRole.VETTING_ADMIN: {
      return "Vetting Admin";
    }
  }
};

export const formatUserRoleToName = (role: UserRole) => {
  switch (role) {
    case UserRole.ALPHA: {
      return "Man";
    }

    case UserRole.MUSE: {
      return "Woman";
    }
  }
};

export const formatUserStatus = (status: UserStatus) => {
  switch (status) {
    case UserStatus.ACTIVE: {
      return "Active";
    }
    case UserStatus.PENDING: {
      return "Pending";
    }
    case UserStatus.REJECTED: {
      return "Rejected";
    }

    case UserStatus.INACTIVE:
    case UserStatus.NOT_FINISHED_PROFILE:
    case UserStatus.NOT_ONBOARDED: {
      return "Inactive";
    }
  }
};

export const formatReferralUserStatus = (status: Referral["status"]) => {
  switch (status) {
    case UserStatus.ACTIVE: {
      return "Active";
    }
    case UserStatus.PENDING: {
      return "Pending";
    }
    case UserStatus.REJECTED:
    case UserStatus.INACTIVE:
    case UserStatus.NOT_FINISHED_PROFILE:
    case UserStatus.NOT_ONBOARDED: {
      return "Rejected";
    }
  }
};

export const formatEventType = (eventType: EventType) => {
  switch (eventType) {
    case EventType.AFFAIR: {
      return "Event";
    }
    case EventType.DATE_NIGHT: {
      return "Date Night";
    }
  }
};

export const formatInstProfile = (link: string) => {
  return link.replace("https://www.instagram.com/", "");
};

export const formatEmail = (email: string): string => {
  // Normalize email by trimming whitespace and converting to lowercase
  return email.trim().toLowerCase();
};

export const formatUserName = (
  firstName: string,
  lastName: string,
  status: UserStatus,
) => {
  const cleanFirst = firstName?.trim() ?? "";
  const cleanLast = lastName?.trim() ?? "";
  const hasName = cleanFirst || cleanLast;

  if (!hasName && status === UserStatus.NOT_ONBOARDED) {
    // For users with NOT_ONBOARDED status, first and last name may be missing
    // (e.g., if they haven't completed onboarding or signed up via Google/Apple)
    return "Not-onboarded";
  }

  if(!cleanFirst && !cleanLast) {
    return "Unknown name"
  }

  return `${firstName} ${lastName}`;
};
